<script lang="ts">
    import { onDestroy } from "svelte";
    import ContentEditableText from "./ContentEditableText";
    export let text: string;
    export let onBlur: ((text: string) => void)|undefined;
    export let toggleUnsavedChanges: () => void;
    let instance: ContentEditableText;
    function init(node: HTMLElement) {
        instance = new ContentEditableText(node, text, onBlur, toggleUnsavedChanges);
    }

    onDestroy(() => {
        instance.destroy();
    });
</script>

<div class="ContentEditable" contenteditable={true} spellcheck={false} use:init />

<style type="text/scss">
    .ContentEditable {
      font-family: "sans_regular", sans-serif;
      box-sizing: border-box;
      font-size: 16px;
      outline: none;
      border: none;
      padding: 5px;
      border-radius: 0;
      &:focus {
          outline: 1px solid #d0d0d0;
      }
      background: #fff;
      line-height: 22px;
      :global(.TextBlock) {
        min-height: 22px;
        box-sizing: content-box;
      }
  
      :global(.TextBlock--header-1) {
        color: #9c1171;
      }
  
      :global(.TextBlock--header-2) {
        color: #9c1171;
      }
  
      :global(.TextBlock--header-3) {
        color: #9c1171;
      }
  
      :global(.TextBlock--header-4) {
        color: #9c1171;
      }
  
      :global(.TextBlock--header-5) {
        color: #9c1171;
      }
  
      :global(.TextBlock--header-6) {
        color: #9c1171;
      }

      :global(.TextBlock--bullet-1),  :global(.TextBlock--done-bullet-1) {
        padding-left: 10px;
      }

      :global(.TextBlock--bullet-2),  :global(.TextBlock--done-bullet-2) {
        padding-left: 20px;
      }

      :global(.TextBlock--bullet-3),  :global(.TextBlock--done-bullet-3) {
        padding-left: 30px;
      }

      :global(.TextBlock--done-bullet-1), :global(.TextBlock--done-bullet-2), :global(.TextBlock--done-bullet-3) {
        text-decoration: line-through;
      }
  
      :global(.emphasis--bold) {
        font-weight: bold;
      }
      :global(.emphasis--italics) {
        font-style: italic;
      }
      :global(.emphasis--underline) {
        text-decoration: underline;
      }
      :global(.em-char) {
        color: rgb(187, 187, 187);
      }
      :global(.note) {
        color: #57d0d6;
      }
    }
  </style>
